/**
 * Build a URL string that's safe to persist or log.
 *
 * Returns `origin + pathname + search` — deliberately NEVER the
 * fragment. Some flows put live credentials in the fragment:
 *   - Supabase magic-link callback (access_token + refresh_token)
 *   - `/mfa/recover` in the client app (single-use recovery token)
 *   - Supabase password-recovery callback (recovery token)
 *
 * `window.location.href` includes the fragment; using it in
 * error_logs / analytics / referral capture leaks live credentials
 * to whichever downstream reads those rows. Callers should prefer
 * this helper anywhere a URL is written server-side or shipped to
 * a third-party (SendGrid, GA4, Meta, Supabase logs, etc.).
 *
 * Returns `null` on the server so callers that render both
 * server- and client-side don't need to null-check `window`.
 */
export function safeUrlForLog(): string | null {
  if (typeof window === 'undefined') return null
  return (
    window.location.origin +
    window.location.pathname +
    window.location.search
  )
}
